var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUser = function SvgUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-72": 53,
    viewBox: "0 0 20.5 22.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.13 10.15A5.542 5.542 0 1 0 13.287.933a5.542 5.542 0 0 0-6.157 9.215m.972-7.761a3.8 3.8 0 0 1 2.106-.639A3.803 3.803 0 0 1 14 5.542a3.792 3.792 0 1 1-5.898-3.153M.875 22.75h18.667a.887.887 0 0 0 .875-.875 9.053 9.053 0 0 0-9.042-9.042H9.042A9.053 9.053 0 0 0 0 21.875a.887.887 0 0 0 .875.875M18.62 21H1.797a7.33 7.33 0 0 1 7.245-6.417h2.333A7.33 7.33 0 0 1 18.62 21",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export default ForwardRef;